<div class="custos-app-layout">
  <!-- Mobile header -->
  <header class="mobile-header">
    <button
      class="mobile-header__hamburger"
      (click)="sidebarOpen.set(true)"
      aria-label="Open navigation menu"
    >
      <app-icon name="hamburger" [size]="24" />
    </button>
    <a class="mobile-header__logo" (click)="onNavigate('/home')">
      <img src="assets/icons/custos-logo-icon.svg" width="20" height="22" alt="Custos" class="mobile-header__logo-icon" />
      <img src="assets/icons/custos-wordmark.svg" width="42" height="8" alt="Custos" class="mobile-header__wordmark" />
    </a>
  </header>

  <!-- Sidebar backdrop (mobile only) -->
  @if (sidebarOpen()) {
    <div
      class="sidebar-backdrop"
      (click)="sidebarOpen.set(false)"
      aria-hidden="true"
    ></div>
  }

  <app-sidebar
    [class.sidebar--open]="sidebarOpen()"
    [currentRoute]="currentRoute()"
    [isOpen]="sidebarOpen()"
    (navigate)="onNavigate($event)"
    (closed)="sidebarOpen.set(false)"
  />
  <main class="custos-app-content">
    @if (walletService.isConnected() && !walletService.isCorrectChain()) {
      <div class="network-warning" role="alert">
        <span class="network-warning__text">{{ 'COMMON.WRONG_NETWORK' | translate }}</span>
        <button class="network-warning__btn" (click)="switchNetwork()">
          {{ 'COMMON.SWITCH_TO' | translate }} {{ expectedChainName() }}
        </button>
      </div>
    }
    <router-outlet />
    <footer class="app-footer">
      <span class="app-footer__text">Secured by</span>
      <img class="app-footer__logo" src="assets/icons/horizontal-logo.svg" alt="GoPlus" width="79" height="16" />
    </footer>
  </main>
</div>
